/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PreviewImport } from './routes/preview'
import { Route as OnboardingImport } from './routes/onboarding'
import { Route as ErrorImport } from './routes/error'
import { Route as AuthErrorImport } from './routes/auth-error'
import { Route as WebsiteImport } from './routes/_website'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as WebsiteIndexImport } from './routes/_website/index'
import { Route as PreviewConsentImport } from './routes/preview/consent'
import { Route as OnboardingWelcomeImport } from './routes/onboarding/welcome'
import { Route as OnboardingPhoneImport } from './routes/onboarding/phone'
import { Route as OnboardingOrganisationImport } from './routes/onboarding/organisation'
import { Route as OnboardingNotificationsImport } from './routes/onboarding/notifications'
import { Route as OnboardingNameImport } from './routes/onboarding/name'
import { Route as OnboardingDateOfBirthImport } from './routes/onboarding/date-of-birth'
import { Route as OnboardingCompleteImport } from './routes/onboarding/complete'
import { Route as OnboardingClinicianNumberImport } from './routes/onboarding/clinician-number'
import { Route as FeedbackPatientImport } from './routes/feedback/patient'
import { Route as WebsiteWaitlistImport } from './routes/_website/waitlist'
import { Route as WebsiteSupportImport } from './routes/_website/support'
import { Route as WebsiteStoryImport } from './routes/_website/story'
import { Route as WebsiteSecurityImport } from './routes/_website/security'
import { Route as WebsiteGetStartedImport } from './routes/_website/get-started'
import { Route as WebsiteFaqsImport } from './routes/_website/faqs'
import { Route as WebsiteEvidenceImport } from './routes/_website/evidence'
import { Route as WebsiteCustomImport } from './routes/_website/custom'
import { Route as WebsiteContactImport } from './routes/_website/contact'
import { Route as WebsiteBlogImport } from './routes/_website/blog'
import { Route as WebsiteAboutImport } from './routes/_website/about'
import { Route as AuthVerifyImport } from './routes/_auth/verify'
import { Route as AuthTryDemoImport } from './routes/_auth/try-demo'
import { Route as AuthTestImport } from './routes/_auth/test'
import { Route as AuthSignupImport } from './routes/_auth/signup'
import { Route as AuthNewUserImport } from './routes/_auth/new-user'
import { Route as AuthNewDiaryInviteImport } from './routes/_auth/new-diary-invite'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordImport } from './routes/_auth/forgot-password'
import { Route as AuthEmailConfirmedImport } from './routes/_auth/email-confirmed'
import { Route as AuthDeleteAccountImport } from './routes/_auth/delete-account'
import { Route as AuthConfirmAccountImport } from './routes/_auth/confirm-account'
import { Route as AuthChangePasswordImport } from './routes/_auth/change-password'
import { Route as AuthAuthenticationCompleteImport } from './routes/_auth/authentication-complete'
import { Route as AuthAuthenticateImport } from './routes/_auth/authenticate'
import { Route as AuthActivateAccountImport } from './routes/_auth/activate-account'
import { Route as AppStatisticsImport } from './routes/_app/statistics'
import { Route as AppRoleImport } from './routes/_app/role'
import { Route as AppProfileImport } from './routes/_app/profile'
import { Route as AppPatientsImport } from './routes/_app/patients'
import { Route as AppNewImport } from './routes/_app/new'
import { Route as AppInviteImport } from './routes/_app/invite'
import { Route as AppCompleteProfileImport } from './routes/_app/complete-profile'
import { Route as AppBuilderImport } from './routes/_app/builder'
import { Route as AppAdminImport } from './routes/_app/admin'
import { Route as PublicFormIndexImport } from './routes/public/form/index'
import { Route as WebsiteBlogIndexImport } from './routes/_website/blog/index'
import { Route as AppSchedulesIndexImport } from './routes/_app/schedules/index'
import { Route as AppProfileIndexImport } from './routes/_app/profile/index'
import { Route as AppInviteIndexImport } from './routes/_app/invite/index'
import { Route as AppDiariesIndexImport } from './routes/_app/diaries/index'
import { Route as AppBuilderIndexImport } from './routes/_app/builder/index'
import { Route as AppAnalyticsIndexImport } from './routes/_app/analytics/index'
import { Route as AppAdminIndexImport } from './routes/_app/admin/index'
import { Route as TrackerTrackerIdSuccessImport } from './routes/tracker/$trackerId/success'
import { Route as TrackerTrackerIdResultsImport } from './routes/tracker/$trackerId/results'
import { Route as PublicScheduleRequestImport } from './routes/public/schedule/request'
import { Route as PublicScheduleScheduleIdImport } from './routes/public/schedule/$scheduleId'
import { Route as PublicFormRequestImport } from './routes/public/form/request'
import { Route as PreviewInviteQrCodeImport } from './routes/preview/invite/qr-code'
import { Route as PreviewConsentConsentIdImport } from './routes/preview/consent/$consentId'
import { Route as WebsiteUseCasesPainInjectionsImport } from './routes/_website/use-cases/pain-injections'
import { Route as WebsiteUseCasesDiabeticFeetImport } from './routes/_website/use-cases/diabetic-feet'
import { Route as WebsiteBlogRemotePatientMonitoringCostSavingsImport } from './routes/_website/blog/remote-patient-monitoring-cost-savings'
import { Route as WebsiteBlogGuideAutomatedManagementImport } from './routes/_website/blog/guide-automated-management'
import { Route as WebsiteBlogEfficientPatientInitiatedFollowUpAfterOrthopaedicInjectionsImport } from './routes/_website/blog/efficient-patient-initiated-follow-up-after-orthopaedic-injections'
import { Route as WebsiteBlogDigitalVsTraditionalPatientSymptomTrackingImport } from './routes/_website/blog/digital-vs-traditional-patient-symptom-tracking'
import { Route as WebsiteBlogDigitalHealthTrackingImport } from './routes/_website/blog/digital-health-tracking'
import { Route as WebsiteBlogDecentralisedClinicalTrialsImport } from './routes/_website/blog/decentralised-clinical-trials'
import { Route as WebsiteBlog5BenefitsRemotePatientMonitoringImport } from './routes/_website/blog/5-benefits-remote-patient-monitoring'
import { Route as AppSchedulesScheduleIdImport } from './routes/_app/schedules/$scheduleId'
import { Route as AppProfilePhoneImport } from './routes/_app/profile/phone'
import { Route as AppProfileOrganisationImport } from './routes/_app/profile/organisation'
import { Route as AppProfileNotificationsImport } from './routes/_app/profile/notifications'
import { Route as AppProfileNhsNumberImport } from './routes/_app/profile/nhs-number'
import { Route as AppProfileNameImport } from './routes/_app/profile/name'
import { Route as AppProfileEmailImport } from './routes/_app/profile/email'
import { Route as AppProfileDateOfBirthImport } from './routes/_app/profile/date-of-birth'
import { Route as AppProfileClinicianNumberImport } from './routes/_app/profile/clinician-number'
import { Route as AppProfileChangePasswordImport } from './routes/_app/profile/change-password'
import { Route as AppProfileAddImagingCenterImport } from './routes/_app/profile/add-imaging-center'
import { Route as AppPatientsDiaryIdImport } from './routes/_app/patients/$diaryId'
import { Route as AppInviteQrCodeImport } from './routes/_app/invite/qr-code'
import { Route as AppHelpPatientImport } from './routes/_app/help/patient'
import { Route as AppHelpClinicianImport } from './routes/_app/help/clinician'
import { Route as AppHeadacheWatchDashboardImport } from './routes/_app/headache-watch/dashboard'
import { Route as AppFootWatchDiaryIdImport } from './routes/_app/foot-watch/$diaryId'
import { Route as AppFisherWatchDashboardImport } from './routes/_app/fisher-watch/dashboard'
import { Route as AppDiariesDiaryIdImport } from './routes/_app/diaries/$diaryId'
import { Route as AppClinicianDiariesImport } from './routes/_app/clinician/diaries'
import { Route as AppBuilderSchedulesImport } from './routes/_app/builder/schedules'
import { Route as AppBuilderQuickstartsImport } from './routes/_app/builder/quickstarts'
import { Route as AppBuilderFormsImport } from './routes/_app/builder/forms'
import { Route as AppAnalyticsArthrosamidImport } from './routes/_app/analytics/arthrosamid'
import { Route as AppAdminUsersStatisticsImport } from './routes/_app/admin/users-statistics'
import { Route as AppAdminUsersImport } from './routes/_app/admin/users'
import { Route as AppAdminUpdateEmailImport } from './routes/_app/admin/update-email'
import { Route as AppAdminTrackersImport } from './routes/_app/admin/trackers'
import { Route as AppAdminInvitedUsersImport } from './routes/_app/admin/invited-users'
import { Route as AppAdminImpersonateUserImport } from './routes/_app/admin/impersonate-user'
import { Route as AppAdminFormsImport } from './routes/_app/admin/forms'
import { Route as AppAdminEventsImport } from './routes/_app/admin/events'
import { Route as PublicFormFormIdIndexImport } from './routes/public/form/$formId/index'
import { Route as AppPatientsDiaryIdIndexImport } from './routes/_app/patients/$diaryId/index'
import { Route as AppOrganisationOrganisationIdIndexImport } from './routes/_app/organisation/$organisationId/index'
import { Route as AppNewDiaryIndexImport } from './routes/_app/new/diary/index'
import { Route as AppDiariesDiaryIdIndexImport } from './routes/_app/diaries/$diaryId/index'
import { Route as AppAdminDiariesIndexImport } from './routes/_app/admin/diaries/index'
import { Route as PublicFormFormIdCompleteImport } from './routes/public/form/$formId/complete'
import { Route as WebsiteHelpExplainerExplainerTypeImport } from './routes/_website/help/explainer/$explainerType'
import { Route as AppProfileMedicalDiabetesImport } from './routes/_app/profile/medical/diabetes'
import { Route as AppPatientsDiaryIdEditImport } from './routes/_app/patients/$diaryId/edit'
import { Route as AppOrganisationOrganisationIdQrCodeImport } from './routes/_app/organisation/$organisationId/qr-code'
import { Route as AppNewDiaryCompleteImport } from './routes/_app/new/diary/complete'
import { Route as AppNewDiaryTemplateIdImport } from './routes/_app/new/diary/$templateId'
import { Route as AppNewDiaryNewDiaryTemplateIdImport } from './routes/_app/new/diary/$newDiaryTemplateId'
import { Route as AppFootWatchNewDiaryShareImport } from './routes/_app/foot-watch/new-diary/share'
import { Route as AppFootWatchDiaryIdEditImport } from './routes/_app/foot-watch/$diaryId/edit'
import { Route as AppFootWatchDiaryIdViewImport } from './routes/_app/foot-watch/$diaryId/_view'
import { Route as AppDiariesDiaryIdHomeImport } from './routes/_app/diaries/$diaryId/home'
import { Route as AppDiariesDiaryIdEditImport } from './routes/_app/diaries/$diaryId/edit'
import { Route as AppBuilderScheduleTemplatesImport } from './routes/_app/builder/schedule/templates'
import { Route as AppBuilderScheduleScheduleIdImport } from './routes/_app/builder/schedule/$scheduleId'
import { Route as AppAdminUserUserIdImport } from './routes/_app/admin/user/$userId'
import { Route as AppAdminOrganisationStatisticsImport } from './routes/_app/admin/organisation/statistics'
import { Route as AppAdminOrganisationLogosImport } from './routes/_app/admin/organisation/logos'
import { Route as AppAdminOrganisationAddImport } from './routes/_app/admin/organisation/add'
import { Route as AppAdminDiariesTypesImport } from './routes/_app/admin/diaries/types'
import { Route as AppAdminCliniciansStatisticsImport } from './routes/_app/admin/clinicians/statistics'
import { Route as AppAdminCliniciansLeaderboardImport } from './routes/_app/admin/clinicians/leaderboard'
import { Route as TrackerTrackerIdFormFormIdIndexImport } from './routes/tracker/$trackerId/form/$formId/index'
import { Route as AppDiariesDiaryIdEditIndexImport } from './routes/_app/diaries/$diaryId/edit/index'
import { Route as AppAdminDiariesDiaryIdIndexImport } from './routes/_app/admin/diaries/$diaryId/index'
import { Route as AppPatientsDiaryIdActionActionIdImport } from './routes/_app/patients/$diaryId/action.$actionId'
import { Route as AppNewDiaryInviteUserImport } from './routes/_app/new/diary/invite/user'
import { Route as AppNewDiaryInviteQrCodeImport } from './routes/_app/new/diary/invite/qr-code'
import { Route as AppNewDiaryInviteDiaryImport } from './routes/_app/new/diary/invite/diary'
import { Route as AppNewDiaryInviteCompleteImport } from './routes/_app/new/diary/invite/complete'
import { Route as AppNewDiaryTemplateIdTrackersImport } from './routes/_app/new/diary/$templateId/trackers'
import { Route as AppNewDiaryTemplateIdOrganisationImport } from './routes/_app/new/diary/$templateId/organisation'
import { Route as AppNewDiaryTemplateIdNameImport } from './routes/_app/new/diary/$templateId/name'
import { Route as AppNewDiaryTemplateIdContactImport } from './routes/_app/new/diary/$templateId/contact'
import { Route as AppFootWatchDiaryIdNewUploadImport } from './routes/_app/foot-watch/$diaryId/new/upload'
import { Route as AppFootWatchDiaryIdNewStartImport } from './routes/_app/foot-watch/$diaryId/new/start'
import { Route as AppFootWatchDiaryIdNewSelectPatientImport } from './routes/_app/foot-watch/$diaryId/new/select-patient'
import { Route as AppFootWatchDiaryIdNewNewPatientImport } from './routes/_app/foot-watch/$diaryId/new/new-patient'
import { Route as AppFootWatchDiaryIdNewInstructionsImport } from './routes/_app/foot-watch/$diaryId/new/instructions'
import { Route as AppFootWatchDiaryIdNewCameraImport } from './routes/_app/foot-watch/$diaryId/new/camera'
import { Route as AppFootWatchDiaryIdNewAddPhotosImport } from './routes/_app/foot-watch/$diaryId/new/add-photos'
import { Route as AppFootWatchDiaryIdEditNameImport } from './routes/_app/foot-watch/$diaryId/edit/name'
import { Route as AppFootWatchDiaryIdEditDiaryImport } from './routes/_app/foot-watch/$diaryId/edit/diary'
import { Route as AppFootWatchDiaryIdViewProgressImport } from './routes/_app/foot-watch/$diaryId/_view/progress'
import { Route as AppFootWatchDiaryIdViewNewImport } from './routes/_app/foot-watch/$diaryId/_view/new'
import { Route as AppFootWatchDiaryIdViewHistoryImport } from './routes/_app/foot-watch/$diaryId/_view/history'
import { Route as AppDiariesDiaryIdHomeNewImport } from './routes/_app/diaries/$diaryId/home/new'
import { Route as AppDiariesDiaryIdHomeHistoryImport } from './routes/_app/diaries/$diaryId/home/history'
import { Route as AppDiariesDiaryIdHomeChartsImport } from './routes/_app/diaries/$diaryId/home/charts'
import { Route as AppDiariesDiaryIdEditDetailsImport } from './routes/_app/diaries/$diaryId/edit/details'
import { Route as AppAdminFormFormIdResultsImport } from './routes/_app/admin/form/$formId/results'
import { Route as PublicFormFormIdPagePageIndexIndexImport } from './routes/public/form/$formId/page/$pageIndex/index'
import { Route as PreviewPatientPatientIdDiaryDiaryIdIndexImport } from './routes/preview/patient/$patientId/diary/$diaryId/index'
import { Route as AppNewDiaryTemplateIdEventsIndexImport } from './routes/_app/new/diary/$templateId/events/index'
import { Route as AppFootWatchNewDiaryPatientIdDiaryIdIndexImport } from './routes/_app/foot-watch/new-diary/$patientId/$diaryId/index'
import { Route as AppFootWatchDiaryIdNewUploadIndexImport } from './routes/_app/foot-watch/$diaryId/new/upload/index'
import { Route as AppNewDiaryFormInterventionInjectionImport } from './routes/_app/new/diary/_form/intervention/injection'
import { Route as AppFootWatchDiaryIdNewUploadUploadingImport } from './routes/_app/foot-watch/$diaryId/new/upload/uploading'
import { Route as AppFootWatchDiaryIdNewUploadMessageImport } from './routes/_app/foot-watch/$diaryId/new/upload/message'
import { Route as AppFootWatchDiaryIdNewUploadCompleteImport } from './routes/_app/foot-watch/$diaryId/new/upload/complete'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId'
import { Route as AppDiariesDiaryIdEditObservationObservationIdImport } from './routes/_app/diaries/$diaryId/edit/observation/$observationId'
import { Route as PreviewRadiologyReportPatientPatientIdEventEventIdIndexImport } from './routes/preview/radiology-report/patient/$patientId/event/$eventId/index'
import { Route as AppNewDiaryTemplateIdEventsSurgeryIndexImport } from './routes/_app/new/diary/$templateId/events/surgery/index'
import { Route as AppNewDiaryTemplateIdEventsShockwaveIndexImport } from './routes/_app/new/diary/$templateId/events/shockwave/index'
import { Route as AppNewDiaryTemplateIdEventsInjectionIndexImport } from './routes/_app/new/diary/$templateId/events/injection/index'
import { Route as AppNewDiaryTemplateIdEventsEducationIndexImport } from './routes/_app/new/diary/$templateId/events/education/index'
import { Route as AppNewDiaryDiaryIdEventsEventIdIndexImport } from './routes/_app/new/diary/$diaryId/events/$eventId/index'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdIndexImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/index'
import { Route as AppDiariesDiaryIdEditEventEventIdIndexImport } from './routes/_app/diaries/$diaryId/edit/event/$eventId/index'
import { Route as PublicFormFormIdEntryEntryIdPagePageIndexImport } from './routes/public/form/$formId/entry.$entryId.page.$pageIndex'
import { Route as AppNewDiaryTemplateIdEventsSurgeryDetailsImport } from './routes/_app/new/diary/$templateId/events/surgery/details'
import { Route as AppNewDiaryTemplateIdEventsShockwaveDetailsImport } from './routes/_app/new/diary/$templateId/events/shockwave/details'
import { Route as AppNewDiaryTemplateIdEventsInjectionDetailsImport } from './routes/_app/new/diary/$templateId/events/injection/details'
import { Route as AppNewDiaryDiaryIdEventsEventIdDetailsImport } from './routes/_app/new/diary/$diaryId/events/$eventId/details'
import { Route as AppFootWatchDiaryIdNewInstructionsAngleSideImport } from './routes/_app/foot-watch/$diaryId/new/instructions/$angle.$side'
import { Route as AppDiariesDiaryIdObservationObservationIdEntryEntryImport } from './routes/_app/diaries/$diaryId/observation/$observationId/entry/$entry'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdTrackerTitleImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/tracker-title'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdStartDateImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/start-date'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdScheduleImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/schedule'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdReferenceDateImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/reference-date'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdFollowUpMethodImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/follow-up-method'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdContactPersonImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/contact-person'
import { Route as TrackerTrackerIdFormFormIdEntryEntryIdPageIndexImport } from './routes/tracker/$trackerId/form/$formId/entry/$entryId/page/index'
import { Route as PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexImport } from './routes/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/index'
import { Route as AppDiariesDiaryIdObservationObservationIdEntryEntryIdIndexImport } from './routes/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/index'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entry'
import { Route as AppDiariesDiaryIdEditEventEventIdSurgerySurgeryIdImport } from './routes/_app/diaries/$diaryId/edit/event/$eventId/surgery/$surgeryId'
import { Route as AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdImport } from './routes/_app/diaries/$diaryId/edit/event/$eventId/injection/$injectionId'
import { Route as TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexImport } from './routes/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/index'
import { Route as AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexImport } from './routes/_app/new/diary/$diaryId/events/$eventId/surgery.$surgeryId/index'
import { Route as AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexImport } from './routes/_app/new/diary/$diaryId/events/$eventId/shockwave.$shockwaveId/index'
import { Route as AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexImport } from './routes/_app/new/diary/$diaryId/events/$eventId/injection.$injectionId/index'
import { Route as AppNewDiaryDiaryIdEventsEventIdEducationEducationIdIndexImport } from './routes/_app/new/diary/$diaryId/events/$eventId/education.$educationId/index'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdIndexImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/index'
import { Route as AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdIndexImport } from './routes/_app/diaries/$diaryId/edit/event/$eventId/injection/$injectionId/index'
import { Route as AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsImport } from './routes/_app/new/diary/$diaryId/events/$eventId/surgery.$surgeryId/details'
import { Route as AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsImport } from './routes/_app/new/diary/$diaryId/events/$eventId/shockwave.$shockwaveId/details'
import { Route as AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsImport } from './routes/_app/new/diary/$diaryId/events/$eventId/injection.$injectionId/details'
import { Route as AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompleteStaffImport } from './routes/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/complete/staff'
import { Route as AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompletePatientImport } from './routes/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/complete/patient'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdTsxImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId.tsx'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryTimeImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/entry-time'
import { Route as AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdDetailsImport } from './routes/_app/diaries/$diaryId/edit/event/$eventId/injection/$injectionId/details'
import { Route as AppDiariesDiaryIdObservationObservationIdEntryEntryIdPagePageIndexIndexImport } from './routes/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/page/$pageIndex/index'
import { Route as AppDiariesDiaryIdObservationObservationIdEntryEntryIdEntryValueEntryValueIdIndexImport } from './routes/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/entry-value/$entryValueId/index'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/index'
import { Route as AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryValueEntryValueIdIndexImport } from './routes/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/entry-value/$entryValueId/index'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/index'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete'
import { Route as AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideImport } from './routes/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle.$side'

// Create/Update Routes

const PreviewRoute = PreviewImport.update({
  path: '/preview',
  getParentRoute: () => rootRoute,
} as any)

const OnboardingRoute = OnboardingImport.update({
  path: '/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const ErrorRoute = ErrorImport.update({
  path: '/error',
  getParentRoute: () => rootRoute,
} as any)

const AuthErrorRoute = AuthErrorImport.update({
  path: '/auth-error',
  getParentRoute: () => rootRoute,
} as any)

const WebsiteRoute = WebsiteImport.update({
  id: '/_website',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const WebsiteIndexRoute = WebsiteIndexImport.update({
  path: '/',
  getParentRoute: () => WebsiteRoute,
} as any)

const PreviewConsentRoute = PreviewConsentImport.update({
  path: '/consent',
  getParentRoute: () => PreviewRoute,
} as any)

const OnboardingWelcomeRoute = OnboardingWelcomeImport.update({
  path: '/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingPhoneRoute = OnboardingPhoneImport.update({
  path: '/phone',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingOrganisationRoute = OnboardingOrganisationImport.update({
  path: '/organisation',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingNotificationsRoute = OnboardingNotificationsImport.update({
  path: '/notifications',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingNameRoute = OnboardingNameImport.update({
  path: '/name',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingDateOfBirthRoute = OnboardingDateOfBirthImport.update({
  path: '/date-of-birth',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingCompleteRoute = OnboardingCompleteImport.update({
  path: '/complete',
  getParentRoute: () => OnboardingRoute,
} as any)

const OnboardingClinicianNumberRoute = OnboardingClinicianNumberImport.update({
  path: '/clinician-number',
  getParentRoute: () => OnboardingRoute,
} as any)

const FeedbackPatientRoute = FeedbackPatientImport.update({
  path: '/feedback/patient',
  getParentRoute: () => rootRoute,
} as any)

const WebsiteWaitlistRoute = WebsiteWaitlistImport.update({
  path: '/waitlist',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteSupportRoute = WebsiteSupportImport.update({
  path: '/support',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteStoryRoute = WebsiteStoryImport.update({
  path: '/story',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteSecurityRoute = WebsiteSecurityImport.update({
  path: '/security',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteGetStartedRoute = WebsiteGetStartedImport.update({
  path: '/get-started',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteFaqsRoute = WebsiteFaqsImport.update({
  path: '/faqs',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteEvidenceRoute = WebsiteEvidenceImport.update({
  path: '/evidence',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteCustomRoute = WebsiteCustomImport.update({
  path: '/custom',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteContactRoute = WebsiteContactImport.update({
  path: '/contact',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteBlogRoute = WebsiteBlogImport.update({
  path: '/blog',
  getParentRoute: () => WebsiteRoute,
} as any)

const WebsiteAboutRoute = WebsiteAboutImport.update({
  path: '/about',
  getParentRoute: () => WebsiteRoute,
} as any)

const AuthVerifyRoute = AuthVerifyImport.update({
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTryDemoRoute = AuthTryDemoImport.update({
  path: '/try-demo',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTestRoute = AuthTestImport.update({
  path: '/test',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSignupRoute = AuthSignupImport.update({
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)

const AuthNewUserRoute = AuthNewUserImport.update({
  path: '/new-user',
  getParentRoute: () => AuthRoute,
} as any)

const AuthNewDiaryInviteRoute = AuthNewDiaryInviteImport.update({
  path: '/new-diary-invite',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthEmailConfirmedRoute = AuthEmailConfirmedImport.update({
  path: '/email-confirmed',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDeleteAccountRoute = AuthDeleteAccountImport.update({
  path: '/delete-account',
  getParentRoute: () => AuthRoute,
} as any)

const AuthConfirmAccountRoute = AuthConfirmAccountImport.update({
  path: '/confirm-account',
  getParentRoute: () => AuthRoute,
} as any)

const AuthChangePasswordRoute = AuthChangePasswordImport.update({
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAuthenticationCompleteRoute = AuthAuthenticationCompleteImport.update(
  {
    path: '/authentication-complete',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthAuthenticateRoute = AuthAuthenticateImport.update({
  path: '/authenticate',
  getParentRoute: () => AuthRoute,
} as any)

const AuthActivateAccountRoute = AuthActivateAccountImport.update({
  path: '/activate-account',
  getParentRoute: () => AuthRoute,
} as any)

const AppStatisticsRoute = AppStatisticsImport.update({
  path: '/statistics',
  getParentRoute: () => AppRoute,
} as any)

const AppRoleRoute = AppRoleImport.update({
  path: '/role',
  getParentRoute: () => AppRoute,
} as any)

const AppProfileRoute = AppProfileImport.update({
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)

const AppPatientsRoute = AppPatientsImport.update({
  path: '/patients',
  getParentRoute: () => AppRoute,
} as any)

const AppNewRoute = AppNewImport.update({
  path: '/new',
  getParentRoute: () => AppRoute,
} as any)

const AppInviteRoute = AppInviteImport.update({
  path: '/invite',
  getParentRoute: () => AppRoute,
} as any)

const AppCompleteProfileRoute = AppCompleteProfileImport.update({
  path: '/complete-profile',
  getParentRoute: () => AppRoute,
} as any)

const AppBuilderRoute = AppBuilderImport.update({
  path: '/builder',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminRoute = AppAdminImport.update({
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)

const PublicFormIndexRoute = PublicFormIndexImport.update({
  path: '/public/form/',
  getParentRoute: () => rootRoute,
} as any)

const WebsiteBlogIndexRoute = WebsiteBlogIndexImport.update({
  path: '/',
  getParentRoute: () => WebsiteBlogRoute,
} as any)

const AppSchedulesIndexRoute = AppSchedulesIndexImport.update({
  path: '/schedules/',
  getParentRoute: () => AppRoute,
} as any)

const AppProfileIndexRoute = AppProfileIndexImport.update({
  path: '/',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppInviteIndexRoute = AppInviteIndexImport.update({
  path: '/',
  getParentRoute: () => AppInviteRoute,
} as any)

const AppDiariesIndexRoute = AppDiariesIndexImport.update({
  path: '/diaries/',
  getParentRoute: () => AppRoute,
} as any)

const AppBuilderIndexRoute = AppBuilderIndexImport.update({
  path: '/',
  getParentRoute: () => AppBuilderRoute,
} as any)

const AppAnalyticsIndexRoute = AppAnalyticsIndexImport.update({
  path: '/analytics/',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminIndexRoute = AppAdminIndexImport.update({
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)

const TrackerTrackerIdSuccessRoute = TrackerTrackerIdSuccessImport.update({
  path: '/tracker/$trackerId/success',
  getParentRoute: () => rootRoute,
} as any)

const TrackerTrackerIdResultsRoute = TrackerTrackerIdResultsImport.update({
  path: '/tracker/$trackerId/results',
  getParentRoute: () => rootRoute,
} as any)

const PublicScheduleRequestRoute = PublicScheduleRequestImport.update({
  path: '/public/schedule/request',
  getParentRoute: () => rootRoute,
} as any)

const PublicScheduleScheduleIdRoute = PublicScheduleScheduleIdImport.update({
  path: '/public/schedule/$scheduleId',
  getParentRoute: () => rootRoute,
} as any)

const PublicFormRequestRoute = PublicFormRequestImport.update({
  path: '/public/form/request',
  getParentRoute: () => rootRoute,
} as any)

const PreviewInviteQrCodeRoute = PreviewInviteQrCodeImport.update({
  path: '/invite/qr-code',
  getParentRoute: () => PreviewRoute,
} as any)

const PreviewConsentConsentIdRoute = PreviewConsentConsentIdImport.update({
  path: '/$consentId',
  getParentRoute: () => PreviewConsentRoute,
} as any)

const WebsiteUseCasesPainInjectionsRoute =
  WebsiteUseCasesPainInjectionsImport.update({
    path: '/use-cases/pain-injections',
    getParentRoute: () => WebsiteRoute,
  } as any)

const WebsiteUseCasesDiabeticFeetRoute =
  WebsiteUseCasesDiabeticFeetImport.update({
    path: '/use-cases/diabetic-feet',
    getParentRoute: () => WebsiteRoute,
  } as any)

const WebsiteBlogRemotePatientMonitoringCostSavingsRoute =
  WebsiteBlogRemotePatientMonitoringCostSavingsImport.update({
    path: '/remote-patient-monitoring-cost-savings',
    getParentRoute: () => WebsiteBlogRoute,
  } as any)

const WebsiteBlogGuideAutomatedManagementRoute =
  WebsiteBlogGuideAutomatedManagementImport.update({
    path: '/guide-automated-management',
    getParentRoute: () => WebsiteBlogRoute,
  } as any)

const WebsiteBlogEfficientPatientInitiatedFollowUpAfterOrthopaedicInjectionsRoute =
  WebsiteBlogEfficientPatientInitiatedFollowUpAfterOrthopaedicInjectionsImport.update(
    {
      path: '/efficient-patient-initiated-follow-up-after-orthopaedic-injections',
      getParentRoute: () => WebsiteBlogRoute,
    } as any,
  )

const WebsiteBlogDigitalVsTraditionalPatientSymptomTrackingRoute =
  WebsiteBlogDigitalVsTraditionalPatientSymptomTrackingImport.update({
    path: '/digital-vs-traditional-patient-symptom-tracking',
    getParentRoute: () => WebsiteBlogRoute,
  } as any)

const WebsiteBlogDigitalHealthTrackingRoute =
  WebsiteBlogDigitalHealthTrackingImport.update({
    path: '/digital-health-tracking',
    getParentRoute: () => WebsiteBlogRoute,
  } as any)

const WebsiteBlogDecentralisedClinicalTrialsRoute =
  WebsiteBlogDecentralisedClinicalTrialsImport.update({
    path: '/decentralised-clinical-trials',
    getParentRoute: () => WebsiteBlogRoute,
  } as any)

const WebsiteBlog5BenefitsRemotePatientMonitoringRoute =
  WebsiteBlog5BenefitsRemotePatientMonitoringImport.update({
    path: '/5-benefits-remote-patient-monitoring',
    getParentRoute: () => WebsiteBlogRoute,
  } as any)

const AppSchedulesScheduleIdRoute = AppSchedulesScheduleIdImport.update({
  path: '/schedules/$scheduleId',
  getParentRoute: () => AppRoute,
} as any)

const AppProfilePhoneRoute = AppProfilePhoneImport.update({
  path: '/phone',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileOrganisationRoute = AppProfileOrganisationImport.update({
  path: '/organisation',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileNotificationsRoute = AppProfileNotificationsImport.update({
  path: '/notifications',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileNhsNumberRoute = AppProfileNhsNumberImport.update({
  path: '/nhs-number',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileNameRoute = AppProfileNameImport.update({
  path: '/name',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileEmailRoute = AppProfileEmailImport.update({
  path: '/email',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileDateOfBirthRoute = AppProfileDateOfBirthImport.update({
  path: '/date-of-birth',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileClinicianNumberRoute = AppProfileClinicianNumberImport.update({
  path: '/clinician-number',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileChangePasswordRoute = AppProfileChangePasswordImport.update({
  path: '/change-password',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppProfileAddImagingCenterRoute = AppProfileAddImagingCenterImport.update(
  {
    path: '/add-imaging-center',
    getParentRoute: () => AppProfileRoute,
  } as any,
)

const AppPatientsDiaryIdRoute = AppPatientsDiaryIdImport.update({
  path: '/$diaryId',
  getParentRoute: () => AppPatientsRoute,
} as any)

const AppInviteQrCodeRoute = AppInviteQrCodeImport.update({
  path: '/qr-code',
  getParentRoute: () => AppInviteRoute,
} as any)

const AppHelpPatientRoute = AppHelpPatientImport.update({
  path: '/help/patient',
  getParentRoute: () => AppRoute,
} as any)

const AppHelpClinicianRoute = AppHelpClinicianImport.update({
  path: '/help/clinician',
  getParentRoute: () => AppRoute,
} as any)

const AppHeadacheWatchDashboardRoute = AppHeadacheWatchDashboardImport.update({
  path: '/headache-watch/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppFootWatchDiaryIdRoute = AppFootWatchDiaryIdImport.update({
  path: '/foot-watch/$diaryId',
  getParentRoute: () => AppRoute,
} as any)

const AppFisherWatchDashboardRoute = AppFisherWatchDashboardImport.update({
  path: '/fisher-watch/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppDiariesDiaryIdRoute = AppDiariesDiaryIdImport.update({
  path: '/diaries/$diaryId',
  getParentRoute: () => AppRoute,
} as any)

const AppClinicianDiariesRoute = AppClinicianDiariesImport.update({
  path: '/clinician/diaries',
  getParentRoute: () => AppRoute,
} as any)

const AppBuilderSchedulesRoute = AppBuilderSchedulesImport.update({
  path: '/schedules',
  getParentRoute: () => AppBuilderRoute,
} as any)

const AppBuilderQuickstartsRoute = AppBuilderQuickstartsImport.update({
  path: '/quickstarts',
  getParentRoute: () => AppBuilderRoute,
} as any)

const AppBuilderFormsRoute = AppBuilderFormsImport.update({
  path: '/forms',
  getParentRoute: () => AppBuilderRoute,
} as any)

const AppAnalyticsArthrosamidRoute = AppAnalyticsArthrosamidImport.update({
  path: '/analytics/arthrosamid',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminUsersStatisticsRoute = AppAdminUsersStatisticsImport.update({
  path: '/users-statistics',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminUsersRoute = AppAdminUsersImport.update({
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminUpdateEmailRoute = AppAdminUpdateEmailImport.update({
  path: '/update-email',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminTrackersRoute = AppAdminTrackersImport.update({
  path: '/trackers',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminInvitedUsersRoute = AppAdminInvitedUsersImport.update({
  path: '/invited-users',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminImpersonateUserRoute = AppAdminImpersonateUserImport.update({
  path: '/impersonate-user',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminFormsRoute = AppAdminFormsImport.update({
  path: '/forms',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminEventsRoute = AppAdminEventsImport.update({
  path: '/events',
  getParentRoute: () => AppAdminRoute,
} as any)

const PublicFormFormIdIndexRoute = PublicFormFormIdIndexImport.update({
  path: '/public/form/$formId/',
  getParentRoute: () => rootRoute,
} as any)

const AppPatientsDiaryIdIndexRoute = AppPatientsDiaryIdIndexImport.update({
  path: '/',
  getParentRoute: () => AppPatientsDiaryIdRoute,
} as any)

const AppOrganisationOrganisationIdIndexRoute =
  AppOrganisationOrganisationIdIndexImport.update({
    path: '/organisation/$organisationId/',
    getParentRoute: () => AppRoute,
  } as any)

const AppNewDiaryIndexRoute = AppNewDiaryIndexImport.update({
  path: '/diary/',
  getParentRoute: () => AppNewRoute,
} as any)

const AppDiariesDiaryIdIndexRoute = AppDiariesDiaryIdIndexImport.update({
  path: '/',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)

const AppAdminDiariesIndexRoute = AppAdminDiariesIndexImport.update({
  path: '/diaries/',
  getParentRoute: () => AppAdminRoute,
} as any)

const PublicFormFormIdCompleteRoute = PublicFormFormIdCompleteImport.update({
  path: '/public/form/$formId/complete',
  getParentRoute: () => rootRoute,
} as any)

const WebsiteHelpExplainerExplainerTypeRoute =
  WebsiteHelpExplainerExplainerTypeImport.update({
    path: '/help/explainer/$explainerType',
    getParentRoute: () => WebsiteRoute,
  } as any)

const AppProfileMedicalDiabetesRoute = AppProfileMedicalDiabetesImport.update({
  path: '/medical/diabetes',
  getParentRoute: () => AppProfileRoute,
} as any)

const AppPatientsDiaryIdEditRoute = AppPatientsDiaryIdEditImport.update({
  path: '/edit',
  getParentRoute: () => AppPatientsDiaryIdRoute,
} as any)

const AppOrganisationOrganisationIdQrCodeRoute =
  AppOrganisationOrganisationIdQrCodeImport.update({
    path: '/organisation/$organisationId/qr-code',
    getParentRoute: () => AppRoute,
  } as any)

const AppNewDiaryCompleteRoute = AppNewDiaryCompleteImport.update({
  path: '/diary/complete',
  getParentRoute: () => AppNewRoute,
} as any)

const AppNewDiaryTemplateIdRoute = AppNewDiaryTemplateIdImport.update({
  path: '/diary/$templateId',
  getParentRoute: () => AppNewRoute,
} as any)

const AppNewDiaryNewDiaryTemplateIdRoute =
  AppNewDiaryNewDiaryTemplateIdImport.update({
    path: '/diary/$newDiaryTemplateId',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppFootWatchNewDiaryShareRoute = AppFootWatchNewDiaryShareImport.update({
  path: '/foot-watch/new-diary/share',
  getParentRoute: () => AppRoute,
} as any)

const AppFootWatchDiaryIdEditRoute = AppFootWatchDiaryIdEditImport.update({
  path: '/edit',
  getParentRoute: () => AppFootWatchDiaryIdRoute,
} as any)

const AppFootWatchDiaryIdViewRoute = AppFootWatchDiaryIdViewImport.update({
  id: '/_view',
  getParentRoute: () => AppFootWatchDiaryIdRoute,
} as any)

const AppDiariesDiaryIdHomeRoute = AppDiariesDiaryIdHomeImport.update({
  path: '/home',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)

const AppDiariesDiaryIdEditRoute = AppDiariesDiaryIdEditImport.update({
  path: '/edit',
  getParentRoute: () => AppDiariesDiaryIdRoute,
} as any)

const AppBuilderScheduleTemplatesRoute =
  AppBuilderScheduleTemplatesImport.update({
    path: '/schedule/templates',
    getParentRoute: () => AppBuilderRoute,
  } as any)

const AppBuilderScheduleScheduleIdRoute =
  AppBuilderScheduleScheduleIdImport.update({
    path: '/schedule/$scheduleId',
    getParentRoute: () => AppBuilderRoute,
  } as any)

const AppAdminUserUserIdRoute = AppAdminUserUserIdImport.update({
  path: '/user/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminOrganisationStatisticsRoute =
  AppAdminOrganisationStatisticsImport.update({
    path: '/organisation/statistics',
    getParentRoute: () => AppAdminRoute,
  } as any)

const AppAdminOrganisationLogosRoute = AppAdminOrganisationLogosImport.update({
  path: '/organisation/logos',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminOrganisationAddRoute = AppAdminOrganisationAddImport.update({
  path: '/organisation/add',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminDiariesTypesRoute = AppAdminDiariesTypesImport.update({
  path: '/diaries/types',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminCliniciansStatisticsRoute =
  AppAdminCliniciansStatisticsImport.update({
    path: '/clinicians/statistics',
    getParentRoute: () => AppAdminRoute,
  } as any)

const AppAdminCliniciansLeaderboardRoute =
  AppAdminCliniciansLeaderboardImport.update({
    path: '/clinicians/leaderboard',
    getParentRoute: () => AppAdminRoute,
  } as any)

const TrackerTrackerIdFormFormIdIndexRoute =
  TrackerTrackerIdFormFormIdIndexImport.update({
    path: '/tracker/$trackerId/form/$formId/',
    getParentRoute: () => rootRoute,
  } as any)

const AppDiariesDiaryIdEditIndexRoute = AppDiariesDiaryIdEditIndexImport.update(
  {
    path: '/',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any,
)

const AppAdminDiariesDiaryIdIndexRoute =
  AppAdminDiariesDiaryIdIndexImport.update({
    path: '/diaries/$diaryId/',
    getParentRoute: () => AppAdminRoute,
  } as any)

const AppPatientsDiaryIdActionActionIdRoute =
  AppPatientsDiaryIdActionActionIdImport.update({
    path: '/action/$actionId',
    getParentRoute: () => AppPatientsDiaryIdRoute,
  } as any)

const AppNewDiaryInviteUserRoute = AppNewDiaryInviteUserImport.update({
  path: '/diary/invite/user',
  getParentRoute: () => AppNewRoute,
} as any)

const AppNewDiaryInviteQrCodeRoute = AppNewDiaryInviteQrCodeImport.update({
  path: '/diary/invite/qr-code',
  getParentRoute: () => AppNewRoute,
} as any)

const AppNewDiaryInviteDiaryRoute = AppNewDiaryInviteDiaryImport.update({
  path: '/diary/invite/diary',
  getParentRoute: () => AppNewRoute,
} as any)

const AppNewDiaryInviteCompleteRoute = AppNewDiaryInviteCompleteImport.update({
  path: '/diary/invite/complete',
  getParentRoute: () => AppNewRoute,
} as any)

const AppNewDiaryTemplateIdTrackersRoute =
  AppNewDiaryTemplateIdTrackersImport.update({
    path: '/trackers',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdOrganisationRoute =
  AppNewDiaryTemplateIdOrganisationImport.update({
    path: '/organisation',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdNameRoute = AppNewDiaryTemplateIdNameImport.update({
  path: '/name',
  getParentRoute: () => AppNewDiaryTemplateIdRoute,
} as any)

const AppNewDiaryTemplateIdContactRoute =
  AppNewDiaryTemplateIdContactImport.update({
    path: '/contact',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppFootWatchDiaryIdNewUploadRoute =
  AppFootWatchDiaryIdNewUploadImport.update({
    path: '/new/upload',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdNewStartRoute =
  AppFootWatchDiaryIdNewStartImport.update({
    path: '/new/start',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdNewSelectPatientRoute =
  AppFootWatchDiaryIdNewSelectPatientImport.update({
    path: '/new/select-patient',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdNewNewPatientRoute =
  AppFootWatchDiaryIdNewNewPatientImport.update({
    path: '/new/new-patient',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdNewInstructionsRoute =
  AppFootWatchDiaryIdNewInstructionsImport.update({
    path: '/new/instructions',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdNewCameraRoute =
  AppFootWatchDiaryIdNewCameraImport.update({
    path: '/new/camera',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdNewAddPhotosRoute =
  AppFootWatchDiaryIdNewAddPhotosImport.update({
    path: '/new/add-photos',
    getParentRoute: () => AppFootWatchDiaryIdRoute,
  } as any)

const AppFootWatchDiaryIdEditNameRoute =
  AppFootWatchDiaryIdEditNameImport.update({
    path: '/name',
    getParentRoute: () => AppFootWatchDiaryIdEditRoute,
  } as any)

const AppFootWatchDiaryIdEditDiaryRoute =
  AppFootWatchDiaryIdEditDiaryImport.update({
    path: '/diary',
    getParentRoute: () => AppFootWatchDiaryIdEditRoute,
  } as any)

const AppFootWatchDiaryIdViewProgressRoute =
  AppFootWatchDiaryIdViewProgressImport.update({
    path: '/progress',
    getParentRoute: () => AppFootWatchDiaryIdViewRoute,
  } as any)

const AppFootWatchDiaryIdViewNewRoute = AppFootWatchDiaryIdViewNewImport.update(
  {
    path: '/new',
    getParentRoute: () => AppFootWatchDiaryIdViewRoute,
  } as any,
)

const AppFootWatchDiaryIdViewHistoryRoute =
  AppFootWatchDiaryIdViewHistoryImport.update({
    path: '/history',
    getParentRoute: () => AppFootWatchDiaryIdViewRoute,
  } as any)

const AppDiariesDiaryIdHomeNewRoute = AppDiariesDiaryIdHomeNewImport.update({
  path: '/new',
  getParentRoute: () => AppDiariesDiaryIdHomeRoute,
} as any)

const AppDiariesDiaryIdHomeHistoryRoute =
  AppDiariesDiaryIdHomeHistoryImport.update({
    path: '/history',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)

const AppDiariesDiaryIdHomeChartsRoute =
  AppDiariesDiaryIdHomeChartsImport.update({
    path: '/charts',
    getParentRoute: () => AppDiariesDiaryIdHomeRoute,
  } as any)

const AppDiariesDiaryIdEditDetailsRoute =
  AppDiariesDiaryIdEditDetailsImport.update({
    path: '/details',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any)

const AppAdminFormFormIdResultsRoute = AppAdminFormFormIdResultsImport.update({
  path: '/form/$formId/results',
  getParentRoute: () => AppAdminRoute,
} as any)

const PublicFormFormIdPagePageIndexIndexRoute =
  PublicFormFormIdPagePageIndexIndexImport.update({
    path: '/public/form/$formId/page/$pageIndex/',
    getParentRoute: () => rootRoute,
  } as any)

const PreviewPatientPatientIdDiaryDiaryIdIndexRoute =
  PreviewPatientPatientIdDiaryDiaryIdIndexImport.update({
    path: '/patient/$patientId/diary/$diaryId/',
    getParentRoute: () => PreviewRoute,
  } as any)

const AppNewDiaryTemplateIdEventsIndexRoute =
  AppNewDiaryTemplateIdEventsIndexImport.update({
    path: '/events/',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute =
  AppFootWatchNewDiaryPatientIdDiaryIdIndexImport.update({
    path: '/foot-watch/new-diary/$patientId/$diaryId/',
    getParentRoute: () => AppRoute,
  } as any)

const AppFootWatchDiaryIdNewUploadIndexRoute =
  AppFootWatchDiaryIdNewUploadIndexImport.update({
    path: '/',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)

const AppNewDiaryFormInterventionInjectionRoute =
  AppNewDiaryFormInterventionInjectionImport.update({
    path: '/diary/intervention/injection',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppFootWatchDiaryIdNewUploadUploadingRoute =
  AppFootWatchDiaryIdNewUploadUploadingImport.update({
    path: '/uploading',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)

const AppFootWatchDiaryIdNewUploadMessageRoute =
  AppFootWatchDiaryIdNewUploadMessageImport.update({
    path: '/message',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)

const AppFootWatchDiaryIdNewUploadCompleteRoute =
  AppFootWatchDiaryIdNewUploadCompleteImport.update({
    path: '/complete',
    getParentRoute: () => AppFootWatchDiaryIdNewUploadRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdImport.update({
    path: '/tracker/$trackerId',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any)

const AppDiariesDiaryIdEditObservationObservationIdRoute =
  AppDiariesDiaryIdEditObservationObservationIdImport.update({
    path: '/observation/$observationId',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any)

const PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute =
  PreviewRadiologyReportPatientPatientIdEventEventIdIndexImport.update({
    path: '/radiology-report/patient/$patientId/event/$eventId/',
    getParentRoute: () => PreviewRoute,
  } as any)

const AppNewDiaryTemplateIdEventsSurgeryIndexRoute =
  AppNewDiaryTemplateIdEventsSurgeryIndexImport.update({
    path: '/events/surgery/',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdEventsShockwaveIndexRoute =
  AppNewDiaryTemplateIdEventsShockwaveIndexImport.update({
    path: '/events/shockwave/',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdEventsInjectionIndexRoute =
  AppNewDiaryTemplateIdEventsInjectionIndexImport.update({
    path: '/events/injection/',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdEventsEducationIndexRoute =
  AppNewDiaryTemplateIdEventsEducationIndexImport.update({
    path: '/events/education/',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdIndexRoute =
  AppNewDiaryDiaryIdEventsEventIdIndexImport.update({
    path: '/diary/$diaryId/events/$eventId/',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdIndexRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdIndexImport.update({
    path: '/',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditEventEventIdIndexRoute =
  AppDiariesDiaryIdEditEventEventIdIndexImport.update({
    path: '/event/$eventId/',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any)

const PublicFormFormIdEntryEntryIdPagePageIndexRoute =
  PublicFormFormIdEntryEntryIdPagePageIndexImport.update({
    path: '/public/form/$formId/entry/$entryId/page/$pageIndex',
    getParentRoute: () => rootRoute,
  } as any)

const AppNewDiaryTemplateIdEventsSurgeryDetailsRoute =
  AppNewDiaryTemplateIdEventsSurgeryDetailsImport.update({
    path: '/events/surgery/details',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdEventsShockwaveDetailsRoute =
  AppNewDiaryTemplateIdEventsShockwaveDetailsImport.update({
    path: '/events/shockwave/details',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryTemplateIdEventsInjectionDetailsRoute =
  AppNewDiaryTemplateIdEventsInjectionDetailsImport.update({
    path: '/events/injection/details',
    getParentRoute: () => AppNewDiaryTemplateIdRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdDetailsRoute =
  AppNewDiaryDiaryIdEventsEventIdDetailsImport.update({
    path: '/diary/$diaryId/events/$eventId/details',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppFootWatchDiaryIdNewInstructionsAngleSideRoute =
  AppFootWatchDiaryIdNewInstructionsAngleSideImport.update({
    path: '/$angle/$side',
    getParentRoute: () => AppFootWatchDiaryIdNewInstructionsRoute,
  } as any)

const AppDiariesDiaryIdObservationObservationIdEntryEntryRoute =
  AppDiariesDiaryIdObservationObservationIdEntryEntryImport.update({
    path: '/observation/$observationId/entry/$entry',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdTrackerTitleRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdTrackerTitleImport.update({
    path: '/tracker-title',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdStartDateRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdStartDateImport.update({
    path: '/start-date',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdScheduleRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdScheduleImport.update({
    path: '/schedule',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdReferenceDateRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdReferenceDateImport.update({
    path: '/reference-date',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdFollowUpMethodRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdFollowUpMethodImport.update({
    path: '/follow-up-method',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdContactPersonRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdContactPersonImport.update({
    path: '/contact-person',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute =
  TrackerTrackerIdFormFormIdEntryEntryIdPageIndexImport.update({
    path: '/tracker/$trackerId/form/$formId/entry/$entryId/page/',
    getParentRoute: () => rootRoute,
  } as any)

const PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute =
  PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexImport.update({
    path: '/patient/$patientId/diary/$diaryId/tracker/$trackerId/',
    getParentRoute: () => PreviewRoute,
  } as any)

const AppDiariesDiaryIdObservationObservationIdEntryEntryIdIndexRoute =
  AppDiariesDiaryIdObservationObservationIdEntryEntryIdIndexImport.update({
    path: '/observation/$observationId/entry/$entryId/',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryImport.update({
    path: '/new/tracker/$trackerId/entry/$entry',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)

const AppDiariesDiaryIdEditEventEventIdSurgerySurgeryIdRoute =
  AppDiariesDiaryIdEditEventEventIdSurgerySurgeryIdImport.update({
    path: '/event/$eventId/surgery/$surgeryId',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any)

const AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdRoute =
  AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdImport.update({
    path: '/event/$eventId/injection/$injectionId',
    getParentRoute: () => AppDiariesDiaryIdEditRoute,
  } as any)

const TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute =
  TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexImport.update({
    path: '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/',
    getParentRoute: () => rootRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute =
  AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexImport.update({
    path: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute =
  AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexImport.update({
    path: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute =
  AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexImport.update({
    path: '/diary/$diaryId/events/$eventId/injection/$injectionId/',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute =
  AppNewDiaryDiaryIdEventsEventIdEducationEducationIdIndexImport.update({
    path: '/diary/$diaryId/events/$eventId/education/$educationId/',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdIndexRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdIndexImport.update({
    path: '/entry/$entryId/',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdIndexRoute =
  AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdIndexImport.update({
    path: '/',
    getParentRoute: () =>
      AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute =
  AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsImport.update({
    path: '/diary/$diaryId/events/$eventId/surgery/$surgeryId/details',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute =
  AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsImport.update({
    path: '/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute =
  AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsImport.update({
    path: '/diary/$diaryId/events/$eventId/injection/$injectionId/details',
    getParentRoute: () => AppNewRoute,
  } as any)

const AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompleteStaffRoute =
  AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompleteStaffImport.update(
    {
      path: '/observation/$observationId/entry/$entryId/complete/staff',
      getParentRoute: () => AppDiariesDiaryIdRoute,
    } as any,
  )

const AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompletePatientRoute =
  AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompletePatientImport.update(
    {
      path: '/observation/$observationId/entry/$entryId/complete/patient',
      getParentRoute: () => AppDiariesDiaryIdRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport.update({
    path: '/new/tracker/$trackerId/entry/$entryId/page',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteImport.update({
    path: '/new/tracker/$trackerId/entry/$entryId/complete',
    getParentRoute: () => AppDiariesDiaryIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdTsxRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdTsxImport.update({
    path: '/entry/$entryId/tsx',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryTimeRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryTimeImport.update({
    path: '/entry/$entryId/entry-time',
    getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
  } as any)

const AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdDetailsRoute =
  AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdDetailsImport.update({
    path: '/details',
    getParentRoute: () =>
      AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdRoute,
  } as any)

const AppDiariesDiaryIdObservationObservationIdEntryEntryIdPagePageIndexIndexRoute =
  AppDiariesDiaryIdObservationObservationIdEntryEntryIdPagePageIndexIndexImport.update(
    {
      path: '/observation/$observationId/entry/$entryId/page/$pageIndex/',
      getParentRoute: () => AppDiariesDiaryIdRoute,
    } as any,
  )

const AppDiariesDiaryIdObservationObservationIdEntryEntryIdEntryValueEntryValueIdIndexRoute =
  AppDiariesDiaryIdObservationObservationIdEntryEntryIdEntryValueEntryValueIdIndexImport.update(
    {
      path: '/observation/$observationId/entry/$entryId/entry-value/$entryValueId/',
      getParentRoute: () => AppDiariesDiaryIdRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexImport.update(
    {
      path: '/$pageIndex/',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryValueEntryValueIdIndexRoute =
  AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryValueEntryValueIdIndexImport.update(
    {
      path: '/entry/$entryId/entry-value/$entryValueId/',
      getParentRoute: () => AppDiariesDiaryIdEditTrackerTrackerIdRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport.update(
    {
      path: '/$pageIndex/foot-photos/upload',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartImport.update(
    {
      path: '/$pageIndex/foot-photos/start',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientImport.update(
    {
      path: '/$pageIndex/foot-photos/select-patient',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientImport.update(
    {
      path: '/$pageIndex/foot-photos/new-patient',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsImport.update(
    {
      path: '/$pageIndex/foot-photos/instructions',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraImport.update(
    {
      path: '/$pageIndex/foot-photos/camera',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosImport.update(
    {
      path: '/$pageIndex/foot-photos/add-photos',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingImport.update(
    {
      path: '/uploading',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageImport.update(
    {
      path: '/message',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteImport.update(
    {
      path: '/complete',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute,
    } as any,
  )

const AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute =
  AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideImport.update(
    {
      path: '/$angle/$side',
      getParentRoute: () =>
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_website': {
      preLoaderRoute: typeof WebsiteImport
      parentRoute: typeof rootRoute
    }
    '/auth-error': {
      preLoaderRoute: typeof AuthErrorImport
      parentRoute: typeof rootRoute
    }
    '/error': {
      preLoaderRoute: typeof ErrorImport
      parentRoute: typeof rootRoute
    }
    '/onboarding': {
      preLoaderRoute: typeof OnboardingImport
      parentRoute: typeof rootRoute
    }
    '/preview': {
      preLoaderRoute: typeof PreviewImport
      parentRoute: typeof rootRoute
    }
    '/_app/admin': {
      preLoaderRoute: typeof AppAdminImport
      parentRoute: typeof AppImport
    }
    '/_app/builder': {
      preLoaderRoute: typeof AppBuilderImport
      parentRoute: typeof AppImport
    }
    '/_app/complete-profile': {
      preLoaderRoute: typeof AppCompleteProfileImport
      parentRoute: typeof AppImport
    }
    '/_app/invite': {
      preLoaderRoute: typeof AppInviteImport
      parentRoute: typeof AppImport
    }
    '/_app/new': {
      preLoaderRoute: typeof AppNewImport
      parentRoute: typeof AppImport
    }
    '/_app/patients': {
      preLoaderRoute: typeof AppPatientsImport
      parentRoute: typeof AppImport
    }
    '/_app/profile': {
      preLoaderRoute: typeof AppProfileImport
      parentRoute: typeof AppImport
    }
    '/_app/role': {
      preLoaderRoute: typeof AppRoleImport
      parentRoute: typeof AppImport
    }
    '/_app/statistics': {
      preLoaderRoute: typeof AppStatisticsImport
      parentRoute: typeof AppImport
    }
    '/_auth/activate-account': {
      preLoaderRoute: typeof AuthActivateAccountImport
      parentRoute: typeof AuthImport
    }
    '/_auth/authenticate': {
      preLoaderRoute: typeof AuthAuthenticateImport
      parentRoute: typeof AuthImport
    }
    '/_auth/authentication-complete': {
      preLoaderRoute: typeof AuthAuthenticationCompleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/change-password': {
      preLoaderRoute: typeof AuthChangePasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/confirm-account': {
      preLoaderRoute: typeof AuthConfirmAccountImport
      parentRoute: typeof AuthImport
    }
    '/_auth/delete-account': {
      preLoaderRoute: typeof AuthDeleteAccountImport
      parentRoute: typeof AuthImport
    }
    '/_auth/email-confirmed': {
      preLoaderRoute: typeof AuthEmailConfirmedImport
      parentRoute: typeof AuthImport
    }
    '/_auth/forgot-password': {
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/login': {
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/new-diary-invite': {
      preLoaderRoute: typeof AuthNewDiaryInviteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/new-user': {
      preLoaderRoute: typeof AuthNewUserImport
      parentRoute: typeof AuthImport
    }
    '/_auth/signup': {
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof AuthImport
    }
    '/_auth/test': {
      preLoaderRoute: typeof AuthTestImport
      parentRoute: typeof AuthImport
    }
    '/_auth/try-demo': {
      preLoaderRoute: typeof AuthTryDemoImport
      parentRoute: typeof AuthImport
    }
    '/_auth/verify': {
      preLoaderRoute: typeof AuthVerifyImport
      parentRoute: typeof AuthImport
    }
    '/_website/about': {
      preLoaderRoute: typeof WebsiteAboutImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/blog': {
      preLoaderRoute: typeof WebsiteBlogImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/contact': {
      preLoaderRoute: typeof WebsiteContactImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/custom': {
      preLoaderRoute: typeof WebsiteCustomImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/evidence': {
      preLoaderRoute: typeof WebsiteEvidenceImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/faqs': {
      preLoaderRoute: typeof WebsiteFaqsImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/get-started': {
      preLoaderRoute: typeof WebsiteGetStartedImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/security': {
      preLoaderRoute: typeof WebsiteSecurityImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/story': {
      preLoaderRoute: typeof WebsiteStoryImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/support': {
      preLoaderRoute: typeof WebsiteSupportImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/waitlist': {
      preLoaderRoute: typeof WebsiteWaitlistImport
      parentRoute: typeof WebsiteImport
    }
    '/feedback/patient': {
      preLoaderRoute: typeof FeedbackPatientImport
      parentRoute: typeof rootRoute
    }
    '/onboarding/clinician-number': {
      preLoaderRoute: typeof OnboardingClinicianNumberImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/complete': {
      preLoaderRoute: typeof OnboardingCompleteImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/date-of-birth': {
      preLoaderRoute: typeof OnboardingDateOfBirthImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/name': {
      preLoaderRoute: typeof OnboardingNameImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/notifications': {
      preLoaderRoute: typeof OnboardingNotificationsImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/organisation': {
      preLoaderRoute: typeof OnboardingOrganisationImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/phone': {
      preLoaderRoute: typeof OnboardingPhoneImport
      parentRoute: typeof OnboardingImport
    }
    '/onboarding/welcome': {
      preLoaderRoute: typeof OnboardingWelcomeImport
      parentRoute: typeof OnboardingImport
    }
    '/preview/consent': {
      preLoaderRoute: typeof PreviewConsentImport
      parentRoute: typeof PreviewImport
    }
    '/_website/': {
      preLoaderRoute: typeof WebsiteIndexImport
      parentRoute: typeof WebsiteImport
    }
    '/_app/admin/events': {
      preLoaderRoute: typeof AppAdminEventsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/forms': {
      preLoaderRoute: typeof AppAdminFormsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/impersonate-user': {
      preLoaderRoute: typeof AppAdminImpersonateUserImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/invited-users': {
      preLoaderRoute: typeof AppAdminInvitedUsersImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/trackers': {
      preLoaderRoute: typeof AppAdminTrackersImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/update-email': {
      preLoaderRoute: typeof AppAdminUpdateEmailImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/users': {
      preLoaderRoute: typeof AppAdminUsersImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/users-statistics': {
      preLoaderRoute: typeof AppAdminUsersStatisticsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/analytics/arthrosamid': {
      preLoaderRoute: typeof AppAnalyticsArthrosamidImport
      parentRoute: typeof AppImport
    }
    '/_app/builder/forms': {
      preLoaderRoute: typeof AppBuilderFormsImport
      parentRoute: typeof AppBuilderImport
    }
    '/_app/builder/quickstarts': {
      preLoaderRoute: typeof AppBuilderQuickstartsImport
      parentRoute: typeof AppBuilderImport
    }
    '/_app/builder/schedules': {
      preLoaderRoute: typeof AppBuilderSchedulesImport
      parentRoute: typeof AppBuilderImport
    }
    '/_app/clinician/diaries': {
      preLoaderRoute: typeof AppClinicianDiariesImport
      parentRoute: typeof AppImport
    }
    '/_app/diaries/$diaryId': {
      preLoaderRoute: typeof AppDiariesDiaryIdImport
      parentRoute: typeof AppImport
    }
    '/_app/fisher-watch/dashboard': {
      preLoaderRoute: typeof AppFisherWatchDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/foot-watch/$diaryId': {
      preLoaderRoute: typeof AppFootWatchDiaryIdImport
      parentRoute: typeof AppImport
    }
    '/_app/headache-watch/dashboard': {
      preLoaderRoute: typeof AppHeadacheWatchDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/help/clinician': {
      preLoaderRoute: typeof AppHelpClinicianImport
      parentRoute: typeof AppImport
    }
    '/_app/help/patient': {
      preLoaderRoute: typeof AppHelpPatientImport
      parentRoute: typeof AppImport
    }
    '/_app/invite/qr-code': {
      preLoaderRoute: typeof AppInviteQrCodeImport
      parentRoute: typeof AppInviteImport
    }
    '/_app/patients/$diaryId': {
      preLoaderRoute: typeof AppPatientsDiaryIdImport
      parentRoute: typeof AppPatientsImport
    }
    '/_app/profile/add-imaging-center': {
      preLoaderRoute: typeof AppProfileAddImagingCenterImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/change-password': {
      preLoaderRoute: typeof AppProfileChangePasswordImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/clinician-number': {
      preLoaderRoute: typeof AppProfileClinicianNumberImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/date-of-birth': {
      preLoaderRoute: typeof AppProfileDateOfBirthImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/email': {
      preLoaderRoute: typeof AppProfileEmailImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/name': {
      preLoaderRoute: typeof AppProfileNameImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/nhs-number': {
      preLoaderRoute: typeof AppProfileNhsNumberImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/notifications': {
      preLoaderRoute: typeof AppProfileNotificationsImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/organisation': {
      preLoaderRoute: typeof AppProfileOrganisationImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/profile/phone': {
      preLoaderRoute: typeof AppProfilePhoneImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/schedules/$scheduleId': {
      preLoaderRoute: typeof AppSchedulesScheduleIdImport
      parentRoute: typeof AppImport
    }
    '/_website/blog/5-benefits-remote-patient-monitoring': {
      preLoaderRoute: typeof WebsiteBlog5BenefitsRemotePatientMonitoringImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/blog/decentralised-clinical-trials': {
      preLoaderRoute: typeof WebsiteBlogDecentralisedClinicalTrialsImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/blog/digital-health-tracking': {
      preLoaderRoute: typeof WebsiteBlogDigitalHealthTrackingImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/blog/digital-vs-traditional-patient-symptom-tracking': {
      preLoaderRoute: typeof WebsiteBlogDigitalVsTraditionalPatientSymptomTrackingImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/blog/efficient-patient-initiated-follow-up-after-orthopaedic-injections': {
      preLoaderRoute: typeof WebsiteBlogEfficientPatientInitiatedFollowUpAfterOrthopaedicInjectionsImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/blog/guide-automated-management': {
      preLoaderRoute: typeof WebsiteBlogGuideAutomatedManagementImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/blog/remote-patient-monitoring-cost-savings': {
      preLoaderRoute: typeof WebsiteBlogRemotePatientMonitoringCostSavingsImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/_website/use-cases/diabetic-feet': {
      preLoaderRoute: typeof WebsiteUseCasesDiabeticFeetImport
      parentRoute: typeof WebsiteImport
    }
    '/_website/use-cases/pain-injections': {
      preLoaderRoute: typeof WebsiteUseCasesPainInjectionsImport
      parentRoute: typeof WebsiteImport
    }
    '/preview/consent/$consentId': {
      preLoaderRoute: typeof PreviewConsentConsentIdImport
      parentRoute: typeof PreviewConsentImport
    }
    '/preview/invite/qr-code': {
      preLoaderRoute: typeof PreviewInviteQrCodeImport
      parentRoute: typeof PreviewImport
    }
    '/public/form/request': {
      preLoaderRoute: typeof PublicFormRequestImport
      parentRoute: typeof rootRoute
    }
    '/public/schedule/$scheduleId': {
      preLoaderRoute: typeof PublicScheduleScheduleIdImport
      parentRoute: typeof rootRoute
    }
    '/public/schedule/request': {
      preLoaderRoute: typeof PublicScheduleRequestImport
      parentRoute: typeof rootRoute
    }
    '/tracker/$trackerId/results': {
      preLoaderRoute: typeof TrackerTrackerIdResultsImport
      parentRoute: typeof rootRoute
    }
    '/tracker/$trackerId/success': {
      preLoaderRoute: typeof TrackerTrackerIdSuccessImport
      parentRoute: typeof rootRoute
    }
    '/_app/admin/': {
      preLoaderRoute: typeof AppAdminIndexImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/analytics/': {
      preLoaderRoute: typeof AppAnalyticsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/builder/': {
      preLoaderRoute: typeof AppBuilderIndexImport
      parentRoute: typeof AppBuilderImport
    }
    '/_app/diaries/': {
      preLoaderRoute: typeof AppDiariesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/invite/': {
      preLoaderRoute: typeof AppInviteIndexImport
      parentRoute: typeof AppInviteImport
    }
    '/_app/profile/': {
      preLoaderRoute: typeof AppProfileIndexImport
      parentRoute: typeof AppProfileImport
    }
    '/_app/schedules/': {
      preLoaderRoute: typeof AppSchedulesIndexImport
      parentRoute: typeof AppImport
    }
    '/_website/blog/': {
      preLoaderRoute: typeof WebsiteBlogIndexImport
      parentRoute: typeof WebsiteBlogImport
    }
    '/public/form/': {
      preLoaderRoute: typeof PublicFormIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/admin/clinicians/leaderboard': {
      preLoaderRoute: typeof AppAdminCliniciansLeaderboardImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/clinicians/statistics': {
      preLoaderRoute: typeof AppAdminCliniciansStatisticsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/diaries/types': {
      preLoaderRoute: typeof AppAdminDiariesTypesImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/organisation/add': {
      preLoaderRoute: typeof AppAdminOrganisationAddImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/organisation/logos': {
      preLoaderRoute: typeof AppAdminOrganisationLogosImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/organisation/statistics': {
      preLoaderRoute: typeof AppAdminOrganisationStatisticsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/admin/user/$userId': {
      preLoaderRoute: typeof AppAdminUserUserIdImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/builder/schedule/$scheduleId': {
      preLoaderRoute: typeof AppBuilderScheduleScheduleIdImport
      parentRoute: typeof AppBuilderImport
    }
    '/_app/builder/schedule/templates': {
      preLoaderRoute: typeof AppBuilderScheduleTemplatesImport
      parentRoute: typeof AppBuilderImport
    }
    '/_app/diaries/$diaryId/edit': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/home': {
      preLoaderRoute: typeof AppDiariesDiaryIdHomeImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/_view': {
      preLoaderRoute: typeof AppFootWatchDiaryIdViewImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/edit': {
      preLoaderRoute: typeof AppFootWatchDiaryIdEditImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/new-diary/share': {
      preLoaderRoute: typeof AppFootWatchNewDiaryShareImport
      parentRoute: typeof AppImport
    }
    '/_app/new/diary/$newDiaryTemplateId': {
      preLoaderRoute: typeof AppNewDiaryNewDiaryTemplateIdImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$templateId': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/complete': {
      preLoaderRoute: typeof AppNewDiaryCompleteImport
      parentRoute: typeof AppNewImport
    }
    '/_app/organisation/$organisationId/qr-code': {
      preLoaderRoute: typeof AppOrganisationOrganisationIdQrCodeImport
      parentRoute: typeof AppImport
    }
    '/_app/patients/$diaryId/edit': {
      preLoaderRoute: typeof AppPatientsDiaryIdEditImport
      parentRoute: typeof AppPatientsDiaryIdImport
    }
    '/_app/profile/medical/diabetes': {
      preLoaderRoute: typeof AppProfileMedicalDiabetesImport
      parentRoute: typeof AppProfileImport
    }
    '/_website/help/explainer/$explainerType': {
      preLoaderRoute: typeof WebsiteHelpExplainerExplainerTypeImport
      parentRoute: typeof WebsiteImport
    }
    '/public/form/$formId/complete': {
      preLoaderRoute: typeof PublicFormFormIdCompleteImport
      parentRoute: typeof rootRoute
    }
    '/_app/admin/diaries/': {
      preLoaderRoute: typeof AppAdminDiariesIndexImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/diaries/$diaryId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/new/diary/': {
      preLoaderRoute: typeof AppNewDiaryIndexImport
      parentRoute: typeof AppNewImport
    }
    '/_app/organisation/$organisationId/': {
      preLoaderRoute: typeof AppOrganisationOrganisationIdIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/patients/$diaryId/': {
      preLoaderRoute: typeof AppPatientsDiaryIdIndexImport
      parentRoute: typeof AppPatientsDiaryIdImport
    }
    '/public/form/$formId/': {
      preLoaderRoute: typeof PublicFormFormIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/admin/form/$formId/results': {
      preLoaderRoute: typeof AppAdminFormFormIdResultsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/diaries/$diaryId/edit/details': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditDetailsImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/_app/diaries/$diaryId/home/charts': {
      preLoaderRoute: typeof AppDiariesDiaryIdHomeChartsImport
      parentRoute: typeof AppDiariesDiaryIdHomeImport
    }
    '/_app/diaries/$diaryId/home/history': {
      preLoaderRoute: typeof AppDiariesDiaryIdHomeHistoryImport
      parentRoute: typeof AppDiariesDiaryIdHomeImport
    }
    '/_app/diaries/$diaryId/home/new': {
      preLoaderRoute: typeof AppDiariesDiaryIdHomeNewImport
      parentRoute: typeof AppDiariesDiaryIdHomeImport
    }
    '/_app/foot-watch/$diaryId/_view/history': {
      preLoaderRoute: typeof AppFootWatchDiaryIdViewHistoryImport
      parentRoute: typeof AppFootWatchDiaryIdViewImport
    }
    '/_app/foot-watch/$diaryId/_view/new': {
      preLoaderRoute: typeof AppFootWatchDiaryIdViewNewImport
      parentRoute: typeof AppFootWatchDiaryIdViewImport
    }
    '/_app/foot-watch/$diaryId/_view/progress': {
      preLoaderRoute: typeof AppFootWatchDiaryIdViewProgressImport
      parentRoute: typeof AppFootWatchDiaryIdViewImport
    }
    '/_app/foot-watch/$diaryId/edit/diary': {
      preLoaderRoute: typeof AppFootWatchDiaryIdEditDiaryImport
      parentRoute: typeof AppFootWatchDiaryIdEditImport
    }
    '/_app/foot-watch/$diaryId/edit/name': {
      preLoaderRoute: typeof AppFootWatchDiaryIdEditNameImport
      parentRoute: typeof AppFootWatchDiaryIdEditImport
    }
    '/_app/foot-watch/$diaryId/new/add-photos': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewAddPhotosImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/camera': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewCameraImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/instructions': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewInstructionsImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/new-patient': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewNewPatientImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/select-patient': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewSelectPatientImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/start': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewStartImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/upload': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadImport
      parentRoute: typeof AppFootWatchDiaryIdImport
    }
    '/_app/new/diary/$templateId/contact': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdContactImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/name': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdNameImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/organisation': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdOrganisationImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/trackers': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdTrackersImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/invite/complete': {
      preLoaderRoute: typeof AppNewDiaryInviteCompleteImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/invite/diary': {
      preLoaderRoute: typeof AppNewDiaryInviteDiaryImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/invite/qr-code': {
      preLoaderRoute: typeof AppNewDiaryInviteQrCodeImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/invite/user': {
      preLoaderRoute: typeof AppNewDiaryInviteUserImport
      parentRoute: typeof AppNewImport
    }
    '/_app/patients/$diaryId/action/$actionId': {
      preLoaderRoute: typeof AppPatientsDiaryIdActionActionIdImport
      parentRoute: typeof AppPatientsDiaryIdImport
    }
    '/_app/admin/diaries/$diaryId/': {
      preLoaderRoute: typeof AppAdminDiariesDiaryIdIndexImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/diaries/$diaryId/edit/': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditIndexImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/tracker/$trackerId/form/$formId/': {
      preLoaderRoute: typeof TrackerTrackerIdFormFormIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/diaries/$diaryId/edit/observation/$observationId': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditObservationObservationIdImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/_app/foot-watch/$diaryId/new/upload/complete': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadCompleteImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadImport
    }
    '/_app/foot-watch/$diaryId/new/upload/message': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadMessageImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadImport
    }
    '/_app/foot-watch/$diaryId/new/upload/uploading': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadUploadingImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadImport
    }
    '/_app/new/diary/_form/intervention/injection': {
      preLoaderRoute: typeof AppNewDiaryFormInterventionInjectionImport
      parentRoute: typeof AppNewImport
    }
    '/_app/foot-watch/$diaryId/new/upload/': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewUploadIndexImport
      parentRoute: typeof AppFootWatchDiaryIdNewUploadImport
    }
    '/_app/foot-watch/new-diary/$patientId/$diaryId/': {
      preLoaderRoute: typeof AppFootWatchNewDiaryPatientIdDiaryIdIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/new/diary/$templateId/events/': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsIndexImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/preview/patient/$patientId/diary/$diaryId/': {
      preLoaderRoute: typeof PreviewPatientPatientIdDiaryDiaryIdIndexImport
      parentRoute: typeof PreviewImport
    }
    '/public/form/$formId/page/$pageIndex/': {
      preLoaderRoute: typeof PublicFormFormIdPagePageIndexIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/contact-person': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdContactPersonImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/follow-up-method': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdFollowUpMethodImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/reference-date': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdReferenceDateImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/schedule': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdScheduleImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/start-date': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdStartDateImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/tracker-title': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdTrackerTitleImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/observation/$observationId/entry/$entry': {
      preLoaderRoute: typeof AppDiariesDiaryIdObservationObservationIdEntryEntryImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/foot-watch/$diaryId/new/instructions/$angle/$side': {
      preLoaderRoute: typeof AppFootWatchDiaryIdNewInstructionsAngleSideImport
      parentRoute: typeof AppFootWatchDiaryIdNewInstructionsImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/details': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdDetailsImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$templateId/events/injection/details': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsInjectionDetailsImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/events/shockwave/details': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsShockwaveDetailsImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/events/surgery/details': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsSurgeryDetailsImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/public/form/$formId/entry/$entryId/page/$pageIndex': {
      preLoaderRoute: typeof PublicFormFormIdEntryEntryIdPagePageIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/diaries/$diaryId/edit/event/$eventId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditEventEventIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdIndexImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$templateId/events/education/': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsEducationIndexImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/events/injection/': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsInjectionIndexImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/events/shockwave/': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsShockwaveIndexImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/_app/new/diary/$templateId/events/surgery/': {
      preLoaderRoute: typeof AppNewDiaryTemplateIdEventsSurgeryIndexImport
      parentRoute: typeof AppNewDiaryTemplateIdImport
    }
    '/preview/radiology-report/patient/$patientId/event/$eventId/': {
      preLoaderRoute: typeof PreviewRadiologyReportPatientPatientIdEventEventIdIndexImport
      parentRoute: typeof PreviewImport
    }
    '/_app/diaries/$diaryId/edit/event/$eventId/injection/$injectionId': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/_app/diaries/$diaryId/edit/event/$eventId/surgery/$surgeryId': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditEventEventIdSurgerySurgeryIdImport
      parentRoute: typeof AppDiariesDiaryIdEditImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entry': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdObservationObservationIdEntryEntryIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/': {
      preLoaderRoute: typeof PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexImport
      parentRoute: typeof PreviewImport
    }
    '/tracker/$trackerId/form/$formId/entry/$entryId/page/': {
      preLoaderRoute: typeof TrackerTrackerIdFormFormIdEntryEntryIdPageIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/diaries/$diaryId/edit/event/$eventId/injection/$injectionId/details': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdDetailsImport
      parentRoute: typeof AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/entry-time': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryTimeImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/tsx': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdTsxImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/complete': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/complete/patient': {
      preLoaderRoute: typeof AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompletePatientImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/complete/staff': {
      preLoaderRoute: typeof AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompleteStaffImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/injection/$injectionId/details': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/details': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/surgery/$surgeryId/details': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsImport
      parentRoute: typeof AppNewImport
    }
    '/_app/diaries/$diaryId/edit/event/$eventId/injection/$injectionId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/education/$educationId/': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdEducationEducationIdIndexImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/injection/$injectionId/': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/shockwave/$shockwaveId/': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexImport
      parentRoute: typeof AppNewImport
    }
    '/_app/new/diary/$diaryId/events/$eventId/surgery/$surgeryId/': {
      preLoaderRoute: typeof AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexImport
      parentRoute: typeof AppNewImport
    }
    '/tracker/$trackerId/form/$formId/entry/$entryId/page/$pageIndex/': {
      preLoaderRoute: typeof TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexImport
      parentRoute: typeof rootRoute
    }
    '/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/entry-value/$entryValueId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdObservationObservationIdEntryEntryIdEntryValueEntryValueIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/observation/$observationId/entry/$entryId/page/$pageIndex/': {
      preLoaderRoute: typeof AppDiariesDiaryIdObservationObservationIdEntryEntryIdPagePageIndexIndexImport
      parentRoute: typeof AppDiariesDiaryIdImport
    }
    '/_app/diaries/$diaryId/edit/tracker/$trackerId/entry/$entryId/entry-value/$entryValueId/': {
      preLoaderRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryValueEntryValueIdIndexImport
      parentRoute: typeof AppDiariesDiaryIdEditTrackerTrackerIdImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/camera': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/new-patient': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/select-patient': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/start': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/complete': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/message': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/uploading': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/upload/': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadImport
    }
    '/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions/$angle/$side': {
      preLoaderRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideImport
      parentRoute: typeof AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  AppRoute.addChildren([
    AppAdminRoute.addChildren([
      AppAdminEventsRoute,
      AppAdminFormsRoute,
      AppAdminImpersonateUserRoute,
      AppAdminInvitedUsersRoute,
      AppAdminTrackersRoute,
      AppAdminUpdateEmailRoute,
      AppAdminUsersRoute,
      AppAdminUsersStatisticsRoute,
      AppAdminIndexRoute,
      AppAdminCliniciansLeaderboardRoute,
      AppAdminCliniciansStatisticsRoute,
      AppAdminDiariesTypesRoute,
      AppAdminOrganisationAddRoute,
      AppAdminOrganisationLogosRoute,
      AppAdminOrganisationStatisticsRoute,
      AppAdminUserUserIdRoute,
      AppAdminDiariesIndexRoute,
      AppAdminFormFormIdResultsRoute,
      AppAdminDiariesDiaryIdIndexRoute,
    ]),
    AppBuilderRoute.addChildren([
      AppBuilderFormsRoute,
      AppBuilderQuickstartsRoute,
      AppBuilderSchedulesRoute,
      AppBuilderIndexRoute,
      AppBuilderScheduleScheduleIdRoute,
      AppBuilderScheduleTemplatesRoute,
    ]),
    AppCompleteProfileRoute,
    AppInviteRoute.addChildren([AppInviteQrCodeRoute, AppInviteIndexRoute]),
    AppNewRoute.addChildren([
      AppNewDiaryNewDiaryTemplateIdRoute,
      AppNewDiaryTemplateIdRoute.addChildren([
        AppNewDiaryTemplateIdContactRoute,
        AppNewDiaryTemplateIdNameRoute,
        AppNewDiaryTemplateIdOrganisationRoute,
        AppNewDiaryTemplateIdTrackersRoute,
        AppNewDiaryTemplateIdEventsIndexRoute,
        AppNewDiaryTemplateIdEventsInjectionDetailsRoute,
        AppNewDiaryTemplateIdEventsShockwaveDetailsRoute,
        AppNewDiaryTemplateIdEventsSurgeryDetailsRoute,
        AppNewDiaryTemplateIdEventsEducationIndexRoute,
        AppNewDiaryTemplateIdEventsInjectionIndexRoute,
        AppNewDiaryTemplateIdEventsShockwaveIndexRoute,
        AppNewDiaryTemplateIdEventsSurgeryIndexRoute,
      ]),
      AppNewDiaryCompleteRoute,
      AppNewDiaryIndexRoute,
      AppNewDiaryInviteCompleteRoute,
      AppNewDiaryInviteDiaryRoute,
      AppNewDiaryInviteQrCodeRoute,
      AppNewDiaryInviteUserRoute,
      AppNewDiaryFormInterventionInjectionRoute,
      AppNewDiaryDiaryIdEventsEventIdDetailsRoute,
      AppNewDiaryDiaryIdEventsEventIdIndexRoute,
      AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdDetailsRoute,
      AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdDetailsRoute,
      AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdDetailsRoute,
      AppNewDiaryDiaryIdEventsEventIdEducationEducationIdIndexRoute,
      AppNewDiaryDiaryIdEventsEventIdInjectionInjectionIdIndexRoute,
      AppNewDiaryDiaryIdEventsEventIdShockwaveShockwaveIdIndexRoute,
      AppNewDiaryDiaryIdEventsEventIdSurgerySurgeryIdIndexRoute,
    ]),
    AppPatientsRoute.addChildren([
      AppPatientsDiaryIdRoute.addChildren([
        AppPatientsDiaryIdEditRoute,
        AppPatientsDiaryIdIndexRoute,
        AppPatientsDiaryIdActionActionIdRoute,
      ]),
    ]),
    AppProfileRoute.addChildren([
      AppProfileAddImagingCenterRoute,
      AppProfileChangePasswordRoute,
      AppProfileClinicianNumberRoute,
      AppProfileDateOfBirthRoute,
      AppProfileEmailRoute,
      AppProfileNameRoute,
      AppProfileNhsNumberRoute,
      AppProfileNotificationsRoute,
      AppProfileOrganisationRoute,
      AppProfilePhoneRoute,
      AppProfileIndexRoute,
      AppProfileMedicalDiabetesRoute,
    ]),
    AppRoleRoute,
    AppStatisticsRoute,
    AppAnalyticsArthrosamidRoute,
    AppClinicianDiariesRoute,
    AppDiariesDiaryIdRoute.addChildren([
      AppDiariesDiaryIdEditRoute.addChildren([
        AppDiariesDiaryIdEditDetailsRoute,
        AppDiariesDiaryIdEditIndexRoute,
        AppDiariesDiaryIdEditObservationObservationIdRoute,
        AppDiariesDiaryIdEditTrackerTrackerIdRoute.addChildren([
          AppDiariesDiaryIdEditTrackerTrackerIdContactPersonRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdFollowUpMethodRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdReferenceDateRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdScheduleRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdStartDateRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdTrackerTitleRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdIndexRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryTimeRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdTsxRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdIndexRoute,
          AppDiariesDiaryIdEditTrackerTrackerIdEntryEntryIdEntryValueEntryValueIdIndexRoute,
        ]),
        AppDiariesDiaryIdEditEventEventIdIndexRoute,
        AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdRoute.addChildren([
          AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdDetailsRoute,
          AppDiariesDiaryIdEditEventEventIdInjectionInjectionIdIndexRoute,
        ]),
        AppDiariesDiaryIdEditEventEventIdSurgerySurgeryIdRoute,
      ]),
      AppDiariesDiaryIdHomeRoute.addChildren([
        AppDiariesDiaryIdHomeChartsRoute,
        AppDiariesDiaryIdHomeHistoryRoute,
        AppDiariesDiaryIdHomeNewRoute,
      ]),
      AppDiariesDiaryIdIndexRoute,
      AppDiariesDiaryIdObservationObservationIdEntryEntryRoute,
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryRoute,
      AppDiariesDiaryIdObservationObservationIdEntryEntryIdIndexRoute,
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdCompleteRoute,
      AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPageRoute.addChildren([
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexIndexRoute,
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosAddPhotosRoute,
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosCameraRoute,
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsRoute.addChildren(
          [
            AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosInstructionsAngleSideRoute,
          ],
        ),
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosNewPatientRoute,
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosSelectPatientRoute,
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosStartRoute,
        AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadRoute.addChildren(
          [
            AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadCompleteRoute,
            AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadMessageRoute,
            AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadUploadingRoute,
            AppDiariesDiaryIdNewTrackerTrackerIdEntryEntryIdPagePageIndexFootPhotosUploadIndexRoute,
          ],
        ),
      ]),
      AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompletePatientRoute,
      AppDiariesDiaryIdObservationObservationIdEntryEntryIdCompleteStaffRoute,
      AppDiariesDiaryIdObservationObservationIdEntryEntryIdEntryValueEntryValueIdIndexRoute,
      AppDiariesDiaryIdObservationObservationIdEntryEntryIdPagePageIndexIndexRoute,
    ]),
    AppFisherWatchDashboardRoute,
    AppFootWatchDiaryIdRoute.addChildren([
      AppFootWatchDiaryIdViewRoute.addChildren([
        AppFootWatchDiaryIdViewHistoryRoute,
        AppFootWatchDiaryIdViewNewRoute,
        AppFootWatchDiaryIdViewProgressRoute,
      ]),
      AppFootWatchDiaryIdEditRoute.addChildren([
        AppFootWatchDiaryIdEditDiaryRoute,
        AppFootWatchDiaryIdEditNameRoute,
      ]),
      AppFootWatchDiaryIdNewAddPhotosRoute,
      AppFootWatchDiaryIdNewCameraRoute,
      AppFootWatchDiaryIdNewInstructionsRoute.addChildren([
        AppFootWatchDiaryIdNewInstructionsAngleSideRoute,
      ]),
      AppFootWatchDiaryIdNewNewPatientRoute,
      AppFootWatchDiaryIdNewSelectPatientRoute,
      AppFootWatchDiaryIdNewStartRoute,
      AppFootWatchDiaryIdNewUploadRoute.addChildren([
        AppFootWatchDiaryIdNewUploadCompleteRoute,
        AppFootWatchDiaryIdNewUploadMessageRoute,
        AppFootWatchDiaryIdNewUploadUploadingRoute,
        AppFootWatchDiaryIdNewUploadIndexRoute,
      ]),
    ]),
    AppHeadacheWatchDashboardRoute,
    AppHelpClinicianRoute,
    AppHelpPatientRoute,
    AppSchedulesScheduleIdRoute,
    AppAnalyticsIndexRoute,
    AppDiariesIndexRoute,
    AppSchedulesIndexRoute,
    AppFootWatchNewDiaryShareRoute,
    AppOrganisationOrganisationIdQrCodeRoute,
    AppOrganisationOrganisationIdIndexRoute,
    AppFootWatchNewDiaryPatientIdDiaryIdIndexRoute,
  ]),
  AuthRoute.addChildren([
    AuthActivateAccountRoute,
    AuthAuthenticateRoute,
    AuthAuthenticationCompleteRoute,
    AuthChangePasswordRoute,
    AuthConfirmAccountRoute,
    AuthDeleteAccountRoute,
    AuthEmailConfirmedRoute,
    AuthForgotPasswordRoute,
    AuthLoginRoute,
    AuthNewDiaryInviteRoute,
    AuthNewUserRoute,
    AuthSignupRoute,
    AuthTestRoute,
    AuthTryDemoRoute,
    AuthVerifyRoute,
  ]),
  WebsiteRoute.addChildren([
    WebsiteAboutRoute,
    WebsiteBlogRoute.addChildren([
      WebsiteBlog5BenefitsRemotePatientMonitoringRoute,
      WebsiteBlogDecentralisedClinicalTrialsRoute,
      WebsiteBlogDigitalHealthTrackingRoute,
      WebsiteBlogDigitalVsTraditionalPatientSymptomTrackingRoute,
      WebsiteBlogEfficientPatientInitiatedFollowUpAfterOrthopaedicInjectionsRoute,
      WebsiteBlogGuideAutomatedManagementRoute,
      WebsiteBlogRemotePatientMonitoringCostSavingsRoute,
      WebsiteBlogIndexRoute,
    ]),
    WebsiteContactRoute,
    WebsiteCustomRoute,
    WebsiteEvidenceRoute,
    WebsiteFaqsRoute,
    WebsiteGetStartedRoute,
    WebsiteSecurityRoute,
    WebsiteStoryRoute,
    WebsiteSupportRoute,
    WebsiteWaitlistRoute,
    WebsiteIndexRoute,
    WebsiteUseCasesDiabeticFeetRoute,
    WebsiteUseCasesPainInjectionsRoute,
    WebsiteHelpExplainerExplainerTypeRoute,
  ]),
  AuthErrorRoute,
  ErrorRoute,
  OnboardingRoute.addChildren([
    OnboardingClinicianNumberRoute,
    OnboardingCompleteRoute,
    OnboardingDateOfBirthRoute,
    OnboardingNameRoute,
    OnboardingNotificationsRoute,
    OnboardingOrganisationRoute,
    OnboardingPhoneRoute,
    OnboardingWelcomeRoute,
  ]),
  PreviewRoute.addChildren([
    PreviewConsentRoute.addChildren([PreviewConsentConsentIdRoute]),
    PreviewInviteQrCodeRoute,
    PreviewPatientPatientIdDiaryDiaryIdIndexRoute,
    PreviewRadiologyReportPatientPatientIdEventEventIdIndexRoute,
    PreviewPatientPatientIdDiaryDiaryIdTrackerTrackerIdIndexRoute,
  ]),
  FeedbackPatientRoute,
  PublicFormRequestRoute,
  PublicScheduleScheduleIdRoute,
  PublicScheduleRequestRoute,
  TrackerTrackerIdResultsRoute,
  TrackerTrackerIdSuccessRoute,
  PublicFormIndexRoute,
  PublicFormFormIdCompleteRoute,
  PublicFormFormIdIndexRoute,
  TrackerTrackerIdFormFormIdIndexRoute,
  PublicFormFormIdPagePageIndexIndexRoute,
  PublicFormFormIdEntryEntryIdPagePageIndexRoute,
  TrackerTrackerIdFormFormIdEntryEntryIdPageIndexRoute,
  TrackerTrackerIdFormFormIdEntryEntryIdPagePageIndexIndexRoute,
])

/* prettier-ignore-end */
